import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStatus } from '../hooks/useAuthStatus';
import Spinner from './Spinner';

export default function PrivateRoute() {
  const { loggedIn, checkingStatus } = useAuthStatus();

  console.log('🔍 PrivateRoute - Checking:', checkingStatus);
  console.log('🔍 PrivateRoute - Logged in:', loggedIn);

  if (checkingStatus) {
    console.log('⏳ PrivateRoute - Showing spinner');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner />
      </div>
    );
  }

  if (!loggedIn) {
    console.log('❌ PrivateRoute - Redirecting to sign-in');
    return <Navigate to="/sign-in" />;
  }

  console.log('✅ PrivateRoute - Rendering Outlet');
  return <Outlet />;
}
